import { gql } from '@apollo/client';

export const AUTHORIZATIONS_X_USER_GROUPS_INVALIDATED = gql`
  subscription authorizationsXUserGroupsInvalidated {
    authorizationsXUserGroupsInvalidated {
      authorizationsXUserGroups {
        authorizationId
        userGroupId
        canRead
      }
    }
  }
`;

export const AUTHORIZATION_X_DOCUMENT_TYPE_X_USER_GROUPS_INVALIDATED = gql`
  subscription authorizationXDocumentTypeXUserGroupsInvalidated {
    authorizationXDocumentTypeXUserGroupsInvalidated {
      authorizationXDocumentTypeXUserGroups {
        authorizationId
        documentStateId
        documentTypeId
        userGroupId
        canRead
      }
    }
  }
`;

export const UNREFINE_AUTHORIZATION_INVALIDATED = gql`
  subscription unrefineAuthorizationInvalidated {
    unrefineAuthorizationInvalidated {
      authorizationId
    }
  }
`;

export const SECURITY_LIST_IMPORTED = gql`
  subscription securityListImported {
    securityListImported
  }
`;
